import React, { Component } from 'react';
import ReturnOrderMain from '../../../components/User/ReturnOrder/returnorder.main';
import LayoutPreload from '../../../components/Preload/layout.preload';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../store/actions';

class UserReturnOrder extends Component {
    componentDidMount() {
        const { updateWording, match, UserGetPurchaseOrderByOrderId } = this.props;
        const orderId = match.params.orderid;
        updateWording();
        UserGetPurchaseOrderByOrderId(orderId);
    }

    render() {
        const { isFetching } = this.props;
        if (isFetching) return <LayoutPreload />;

        return <ReturnOrderMain />;
    }
}

const mapStateToProps = ({ user }) => ({
    isFetching: user.makeReturn.isFetching,
    isError: user.makeReturn.error
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            updateWording: Actions.updateWording,
            UserGetPurchaseOrderByOrderId: Actions.UserGetPurchaseOrderByOrderId
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserReturnOrder);
